<template>
  <div class="swiper-container slider">
    <div class="swiper-wrapper">
        <slot/>
        <div
        v-for="(item, index) in items"
        :Key="index"
        v-if="items"
        class="swiper-slide">
            <slot
                :item="item"
                name="item"/>
        </div>
    </div>

    <!-- If we need pagination -->
    <div
        v-if="pagination"
        ref="pagination"
        class="swiper-pagination"/>

    <!-- If we need navigation buttons -->
    <slot
        v-if="$slots.pagination && pagination"
        name="pagination"/>
    <slot
        v-if="$slots.navigation && navigation"
        name="navigation"/>

    <div
        v-if="!$slots.navigation && navigation"
        class="swiper-prev">
        <span class="iconfont icon-xiangzuojiankuohao"/>
    </div>
    <div
        v-if="!$slots.navigation && navigation"
        class="swiper-next">
        <span class="iconfont icon-xiangyoujiankuohao"/>
    </div>

  </div>
</template>

<script>
/* ============
     * Swiper
     * ============
     *
     * http://idangero.us/swiper/
     * https://github.com/nolimits4web/Swiper
     */
import Swiper from 'swiper/dist/js/swiper.min';

export default {
    components: {},
    filters: {},
    directive: {},
    props: ['items', 'pagination', 'navigation', 'config', 'tid', 'type'],
    data() {
        return {
            default_config: {},
            swiper: null,
        };
    },
    computed: {},
    watch: {
        'config.slidesPerView'(val) {
            if (typeof this.config === 'object') Object.assign(this.default_config, this.config);
            this.swiper.update();
        },
    },
    mounted() {
        if (this.$slots.default) {
            for (const i of this.$el.querySelectorAll('.swiper-wrapper > div')) {
                i.classList.add('swiper-slide');
            }
        }
        if (typeof this.config === 'object') Object.assign(this.default_config, this.config);

        if (this.pagination) {
            const setPagination = typeof this.pagination !== 'object' && {};
            Object.assign(this.default_config, setPagination, {
                // pagination: this.$refs.pagination,
                // clickable: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                    bulletActiveClass: 'my-bullet-active',
                },
            });
        }
        if (this.navigation) {
            let isLoop = false;
            if (this.type === 'time') isLoop = false;
            else isLoop = true;
            const setNavigation = typeof this.navigation !== 'object' && {};
            Object.assign(this.default_config, setNavigation, {
                observer: true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents: true,
                autoplay: false,
                // loop: isLoop,
                loop: false,
                // speed: 600,
                navigation: {
                    nextEl: '.swiper-next',
                    prevEl: '.swiper-prev',
                },
                onSlideChangeEnd: function(swiper){ 
            　　　this.swiper.update()
                }
            });
        }
        this.$nextTick(() => {
            this.swiper = new Swiper(this.$el, this.default_config);
        });
    },
    updated() {
        if (this.swiper) this.swiper.update();
    },
    beforeDestroy() {
        if (this.swiper) {
            this.swiper.destroy();
            delete this.swiper;
        }
    },
    methods: {
        slideNext() {
            this.swiper.slideNext();
        },
        slidePrev() {
            this.swiper.slidePrev();
        },
        changeUpdate() {
            this.swiper.update();
        },
    },
};
</script>
<style lang="css" src="swiper/dist/css/swiper.css"></style>
<style lang="scss">
    .swiper-container {
        z-index: 0;
    }
    .my-bullet-active {
        color: #fff;
        background: #fff;
        opacity: 1;
    }
</style>

